var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"main dashboard-index"},[(_vm.hasTenant && _vm.loadedInfoUser && _vm.termsAccepted)?_c('dashboards-carousel',{ref:"dashboard"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }